module.exports = "/_next/static/images/AWSCDSingapore2-89eca28b170d57f4352a8d352c07f9fc.jpg";